import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { OutlineLabel } from '../../../atoms/OutlineLabel';

import css from './LabeledContainer.module.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  contentsPadding?: boolean;
  description?: string;
  errorStyle?: boolean;
  label: string;
  paddingTop?: boolean;
  requiredLabel?: boolean;
  noBorderBottom?: boolean;
}

const LabeledContainer = ({
  className,
  children,
  contentsPadding,
  description,
  errorStyle,
  label,
  paddingTop,
  requiredLabel,
  noBorderBottom,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(css.LabeledContainer, className);
  const labelclasses = classNames(css.LabeledContainer__Label, {
    [css.isRequired]: requiredLabel,
    [css.withPaddingTop]: paddingTop,
  });
  const contentsClasses = classNames(css.LabeledContainer__Contents, {
    [css.withContentsPadding]: contentsPadding,
    [css.isError]: errorStyle,
    [css.noBorderBottom]: noBorderBottom,
  });

  return (
    <div className={classes}>
      <div className={labelclasses}>
        <div className={css.LabeledContainer__LabelInner}>
          {label}
          {requiredLabel && (
            <OutlineLabel
              className={css.LabeledContainer__Required}
              label={intl.formatMessage({
                id: 'labeledContainer.required',
              })}
            />
          )}
        </div>
        {description && (
          <span className={css.LabeledContainer__Description}>
            {description}
          </span>
        )}
      </div>
      <div className={contentsClasses}>{children}</div>
    </div>
  );
};

export default LabeledContainer;
